import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "evergreen-ui";
import "./header.css";
import { IMAGE_PATH } from "../../Utils/variables";
const Header = ({
  title,
  customMg,
  closeBtn,
  onClose,
  changePasswordBtn,
  onOpenModal,
  backNavigation
}) => {
  const navigate = useNavigate()
  return (
    <div className="headerMaindiv">
      <p className="HeaderHeading" style={{ marginLeft: customMg }}>
        {backNavigation && <img style={{marginRight: '10px', cursor: 'pointer'}} src={IMAGE_PATH + "back-icon.svg"} alt="" onClick={() => navigate(-1)} />}
        {title}
      </p>
      {changePasswordBtn && (
        <div>
          <div
            className="poppinFont ResetBtn"
            onClick={onOpenModal}
            width={200}
          >
            <div className="resetBtnHeader">
              <img src={IMAGE_PATH + "resetPasswordLogo.svg"} alt="" />
              <span className="resetPasswordMargin">Change Password</span>
            </div>
          </div>
        </div>
      )}
      {closeBtn && (
        <img
          className="headerSvg"
          src="./images/stratum/close.svg"
          alt=""
          onClick={() => onClose()}
        />
      )}
    </div>
  );
};

export default Header;
